export const ADMIN_ROUTES = ['clinic-launches'] as const;
export type AdminRoute = (typeof ADMIN_ROUTES)[number];

export const CLINIC_PORTAL_WORKSPACES = ['creation', 'existing'] as const;
export type ClinicPortalWorkspace = (typeof CLINIC_PORTAL_WORKSPACES)[number];
